import styled from 'styled-components';
import imageBackground from "../_static/others/Wallet-Hero.jpg";

export const Header = styled.div`
        background: url(${imageBackground});
        background-size: cover;
        background-position: center;
        border-bottom: 2px solid #fff;
        height: 40vh;        
        left: 0;
        margin: 0;
        position: absolute;
        top: 0;
        width: 100%;
    `;


export const SectionDetail = styled.div`
    .fondo-degradado {
          background: -webkit-Linear-gradient(to Right,#26407A,#40BCC1);
          background: Linear-gradient(to Right,#26407A,#40BCC1);
          min-height: 100vh;
          width: 100%;
    }
`;

export const Body = styled.div`
        height: 100vh;
        width: 100%;
    `;